/* global analytics */

import React, { Component } from 'react';

export default class Error404 extends Component {

    componentWillMount() {
        if(process.env.NODE_ENV === 'production') analytics.page("Error 404");
        window.Intercom("update");
    }

    render() {
        const style = {
            base: {
                textAlign: 'center',
                paddingTop: 100,
                fontWeight: 600,
            },
            h4: {
                margin: 20,
                fontSize: 20,
            },
            p: {
                maxWidth: 540,
                margin: '0 auto',
            },
            span: {
                color: '#999'
            }
        };
        return (
            <main style={style.base}>
                <h4 style={style.h4}><span style={style.span}>Error 404 &mdash;</span> Well, this is awkward.</h4>
                <p style={style.p}>We can't find the page you're looking for. Please check if you typed the URL correctly. If you believe this is a bug, please report it via the chat button in the bottom right corner. Click on one of the navigation items below to get to the page you're looking for.</p>
            </main>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/Error404.js